module.exports = __webpack_public_path__ + "static/media/SalleConference4Thumb.1b33fa22.jpg";